import React, { useRef, useState } from "react";
import "./Contact.css";
import conimg from "./contactimg.jpg";
// import emailjs from "@emailjs/browser";

const Contact = () => {
  return (
    <>
      <div className="bada">
        <div className="contain">
          <form action="#" method="post">
            <h1>Contact Us</h1>
            <p>Let's talk</p>

            <div className="column">
              <label htmlFor="the-name">Your Name</label>
              <input
                type="text"
                name="name"
                id="the-name"
                placeholder="What's Your Good Name ??"
              />

              <label htmlFor="the-email">Email Address</label>
              <input
                type="email"
                name="email"
                id="the-email"
                placeholder="You email address"
              />

              <label htmlFor="the-phone">Phone Number</label>
              <input
                type="tel"
                name="phone"
                id="the-phone"
                placeholder="Your Phone Number"
              />
            </div>
            <div className="column">
              <label htmlFor="the-message">Message</label>
              <textarea name="message" id="the-message"></textarea>

              <input type="submit" value="Send Message" />
            </div>
          </form>
        </div>
        <div className="conimg"></div>
      </div>
    </>
  );
};

export default Contact;
